import { useContext, createContext } from "react";
import { baseURL } from "../lib";
import { useAuth } from "./AuthContext";
import axios from 'axios'

const LocationContext = createContext()

const LocationProvider = ({ children }) => {

    const { auth, toast } = useAuth();

    const headers = {
        Authorization: auth?.token,
    };

    const getAllLocations = async (filter) => {
        try {
            const { page, search, limit } = filter

            let { data } = await axios.get(`${baseURL}/admin/location?filter=${search ? search : null}&limit=${limit ? limit : null}&page=${page ? page : null}`, { headers })
            if (data.error === false) {
                return data.data
            }
        } catch (error) {
            toast({ title: error?.response?.data?.message, position: 'top', status: 'error', isClosable: true })
        }
    }

    const fetchAllLocations = async () => {
        try {
            let { data } = await axios.get(`${baseURL}/admin/location/fetch`, { headers })
            if (data.error === false) {
                return data.data
            }
        } catch (error) {
            toast({ title: error?.response?.data?.message, position: 'top', status: 'error', isClosable: true })
        }
    }

    const getSingleLocation = async (id) => {
        try {
            
            let { data } = await axios.get(`${baseURL}/admin/location/${id}`, { headers })
            
            if (data.error === false) {
                return data.data
            } else {
                toast({ title: data.message, position: 'top', status: 'error', isClosable: true });
            }
        } catch (error) {
            toast({ title: error?.response?.data?.message, position: 'top', status: 'error', isClosable: true })
        }
    }

    const createLocation = async (locationDetail) => {
        try {
            const { data } = await axios.post(`${baseURL}/admin/location/create`, locationDetail, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast({ title: data.message, position: 'top', status: 'success', isClosable: true });
                }, 500);
                return data
            } else {
                toast({ title: data.message, position: 'top', status: 'error', isClosable: true });
            }
        } catch (error) {
            if (error.response) {
                const errors = error.response.data.errors;
                if (errors && Array.isArray(errors) && errors.length > 0) {
                    if (errors.length > 1) {
                        toast({ title: 'Please fill all mandatory fields.', position: 'top', status: 'error', isClosable: true });
                    } else {
                        toast({ title: errors[0].msg, position: 'top', status: 'error', isClosable: true });
                    }
                }
            } else {
                toast({ title: error?.response?.data?.message, position: 'top', status: 'error', isClosable: true })
            }
        }
    }

    const updateLocation = async (id, locationDetail) => {
        try {
            const { data } = await axios.put(`${baseURL}/admin/location/update/${id}`, locationDetail, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast({ title: data.message, position: 'top', status: 'success', isClosable: true });
                }, 500);
                return data
            } else {
                toast({ title: data.message, position: 'top', status: 'error', isClosable: true });
            }
        } catch (error) {
            if (error.response) {
                const errors = error.response.data.errors;
                if (errors && Array.isArray(errors) && errors.length > 0) {
                    if (errors.length > 1) {
                        toast({ title: 'Please fill all mandatory fields.', position: 'top', status: 'error', isClosable: true });
                    } else {
                        toast({ title: errors[0].msg, position: 'top', status: 'error', isClosable: true });
                    }
                }
            } else {
                toast({ title: error?.response?.data?.message, position: 'top', status: 'error', isClosable: true })
            }
        }
    }

    const deleteLocation = async (id) => {
        try {
            const { data } = await axios.put(`${baseURL}/admin/location/delete/${id}`, { headers });
            if (data.error === false) {
                toast({ title: data.message, position: 'top', status: 'success', isClosable: true });
                return data
            } else {
                toast({ title: data.message, position: 'top', status: 'error', isClosable: true });
            }
        } catch (error) {
            toast({ title: error?.response?.data?.message, position: 'top', status: 'error', isClosable: true })
        }
    }

    return (
        <LocationContext.Provider value={{ createLocation, getAllLocations, fetchAllLocations, getSingleLocation, updateLocation, deleteLocation }}>
            {children}
        </LocationContext.Provider>
    )
}

const useLocation = () => useContext(LocationContext)

export { useLocation, LocationProvider }